function addCustomClassByJs(documentTab){

    documentTab.forEach(element => {
        
        const btnTabOptions = element.querySelector('.content-btn-tabs')
        btnTabOptions.classList.add('js-container-btns');

        const containerTabs = element.querySelector('.content-tabs');
        containerTabs.classList.add('js-content-tabs');
        
        btnTabActivatedUrl(btnTabOptions, containerTabs);

        btnTabOptions.childNodes.forEach( childNode =>{
            childNode.addEventListener('click', listener=>{
                tabToUrl(listener.target);
                removeClass(btnTabOptions, containerTabs);
                btnTabActivatedUrl(btnTabOptions, containerTabs);
            })
        })

    });    

}

//remove class
const removeClass = (btnTab, contentTab) =>{

   btnTab.childNodes.forEach(element =>{
        if(!element.length && element.classList.contains('is-active-tab')){
            element.classList.remove('is-active-tab');
        } 
   })

    contentTab.childNodes.forEach(element =>{
        if(!element.length && element.classList.contains('is-active-content')){
            element.classList.remove('is-active-content');
        }  
    })

}


//to send Tab name to url
const tabToUrl = (target) =>{
    
    const textToSend = target.innerText;
    const textToSendParse = textToSend
        .normalize("NFD")
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase();

    const url = new URL(window.location);
    const params = url.searchParams;
    
    textToSendParse && params.set('section', textToSendParse.trim())
    window.history.pushState('', '', url.search);
}


//to get url section to show tab
const btnTabActivatedUrl = (btnTabs, contentTabs) =>{

    let listTitles = []
    const url = new URL(window.location);
    const tabSelected = url.searchParams.get('section');

    if(tabSelected){

        btnTabs.childNodes.forEach(element =>{

            const elementInnerText = element.innerText;
            if(elementInnerText){
    
                const elementInnerTextParset = elementInnerText
                    .normalize("NFD")
                    .replace(/[^a-zA-Z0-9 ]/g, "")
                    .replace(/\s+/g, "-")
                    .toLowerCase();
    
                listTitles.push(elementInnerTextParset);
    
                if(elementInnerTextParset == tabSelected){
                    element.classList.add('is-active-tab');
                }
    
            }
        })
    
        //Start Content Tabs
        let i = 0;
        contentTabs.childNodes.forEach(element =>{
       
            if(listTitles[i] == tabSelected && !element.length){
                element.classList.add('is-active-content');
            }
    
            if(!element.length){
                // console.log(listTitles[i].trim());
                element.classList.add(listTitles[i].trim())
                i++
            }  
        })
    }else{
        btnTabs.firstElementChild.classList.add('is-active-tab');  
        contentTabs.firstElementChild.classList.add('is-active-content');
    }

}




window.addEventListener("load", function(event){
    const contentTabU = document.querySelectorAll('.init-tabs');
    
    contentTabU.forEach(content =>{
        const documentTab = content.querySelectorAll('.js-container-tabs');
        addCustomClassByJs(documentTab);
    })       
});

